import {
  ClubBean,
  ClubPropertiesDTOWithRawPhoneNumberCountry,
  CustomPaymentCategoryDTO,
  FeatureFlags,
  StripeConnectStatus,
} from "@gymflow/types";
import { AxiosInstance } from "axios";

export type ClubApiType = ReturnType<typeof clubApi>;

const clubApi = (axiosInstance: AxiosInstance, clubId: number) => {
  return {
    findById(id: number) {
      return axiosInstance.get<ClubBean>(`club/${id}`);
    },
    properties() {
      return axiosInstance.get<ClubPropertiesDTOWithRawPhoneNumberCountry>(
        `club/${clubId}/properties`,
      );
    },
    connectStatus(clubId: number) {
      return axiosInstance.get<StripeConnectStatus>(`club/${clubId}/connect`);
    },
    featureFlags(clubId: number) {
      return axiosInstance.get<FeatureFlags>(`club/${clubId}/feature-flags`);
    },
    details(clubId: number) {
      return axiosInstance.get<ClubBean>(`club/${clubId}/details`);
    },
    updateDetails(clubId: number, payload: Partial<ClubBean>) {
      return axiosInstance.patch<ClubBean>(`club/${clubId}/details`, payload);
    },
    updateTerms(clubId: number, payload: FormData) {
      return axiosInstance.post<ClubBean>(
        `club/${clubId}/details/terms-conditions`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    },
    stripeOnboardAccount(clubId: number) {
      return axiosInstance.put<string>(
        `club/${clubId}/account/onboard-account`,
      );
    },
    stripeSession(clubId: number) {
      return axiosInstance.get<string>(`club/${clubId}/account/session`);
    },
    stripeCompleteOnboard() {
      return axiosInstance.put(`club/${clubId}/account/onboard-account/status`);
    },
    customPaymentCategory(clubId: number) {
      return axiosInstance.get<CustomPaymentCategoryDTO[]>(
        `club/${clubId}/custom-payment-category`,
      );
    },
  };
};

export default clubApi;
